import React from 'react';
import PropTypes from "prop-types";
import { FormValidation } from "calidation";

import Button from "../../components/buttons/button";
import * as buttonConstants from "../../components/buttons/buttonConstants";
import TextField from "../../components/inputs/textField";

const ItemListSearchForm = ({config}) => {
    let formConfig = {
        NameContains: {}
    };
    return (
        <FormValidation onSubmit={config.onSearchSubmit} config={formConfig} initialValues={config.itemSearchCriteria} >
            {({ fields, setField }) => (
                <div className={"input-bottom-alignment"}>
                    <div className={"grid-x grid-padding-x align-bottom"}>
                        <div className={"cell medium-3 large-3"}>
                            <TextField config={{
                                name: "NameContains",
                                label: "Item Name:",
                                maxLength: 50,
                                showLabel: true,
                                value: fields.NameContains,
                                inputClass: "margin-bottom-0"
                            }} />
                        </div>
                        <div className={"cell medium-7 large-7"}>
                            <div className={"button-group"}>
                                <Button config={{
                                    name: "btnClearItemSearch",
                                    label: "Clear",
                                    onClick: (event) => config.clearCriteria(event, setField),
                                    btnClass: "light",
                                    btnType: buttonConstants.BUTTON_TYPE_BUTTON
                                }} />
                                <Button config={{
                                    name: "btnSearchItems",
                                    label: "Search",
                                    disabled: config.isLoading
                                }} />
                            </div>
                        </div>
                        <div className={"cell medium-2 large-2 text-right"}>
                            <Button config={{
                                name: "btnCreateItem",
                                label: "Create Item",
                                onClick: config.onAddItem,
                                btnClass: "light",
                                btnType: buttonConstants.BUTTON_TYPE_BUTTON
                            }}/>
                        </div>
                    </div>
                </div>
            )}
        </FormValidation>
    );
};

ItemListSearchForm.propTypes = {
    config: PropTypes.shape({
        onSearchSubmit: PropTypes.func.isRequired,
        isLoading: PropTypes.bool.isRequired,
        clearCriteria: PropTypes.func.isRequired,
        itemSearchCriteria: PropTypes.object,
        onAddItem: PropTypes.func.isRequired
    })
};

export default ItemListSearchForm;